import { useEffect } from "react";
import { isEmbeddedMode } from "app/utils/auth";

/**
 * Keeps embedded iframe apps sized to the visible viewport on mobile Safari,
 * where 100% height can exceed the area above the browser chrome.
 */
export function useEmbeddedViewportHeight(): void {
  useEffect(() => {
    if (!isEmbeddedMode() || typeof window === "undefined") {
      return;
    }

    const updateHeight = () => {
      const height = window.visualViewport?.height ?? window.innerHeight;
      document.documentElement.style.setProperty(
        "--embedded-viewport-height",
        `${Math.round(height)}px`
      );
    };

    updateHeight();
    window.visualViewport?.addEventListener("resize", updateHeight);
    window.visualViewport?.addEventListener("scroll", updateHeight);
    window.addEventListener("resize", updateHeight);
    window.addEventListener("orientationchange", updateHeight);

    return () => {
      window.visualViewport?.removeEventListener("resize", updateHeight);
      window.visualViewport?.removeEventListener("scroll", updateHeight);
      window.removeEventListener("resize", updateHeight);
      window.removeEventListener("orientationchange", updateHeight);
      document.documentElement.style.removeProperty("--embedded-viewport-height");
    };
  }, []);
}
